/** หน่วยขายเริ่มต้น — สต็อก/ออเดอร์ใช้หน่วยนี้ */
export const DEFAULT_STOCK_UNIT = "ຊິ້ນ";

export type VariantUnitConfig = {
  stockUnitLabel?: string | null;
  receiveUnitLabel?: string | null;
  receiveConversionFactor?: number | string | null;
};

export function normalizeStockUnitLabel(label?: string | null): string {
  const trimmed = label?.trim();
  return trimmed || DEFAULT_STOCK_UNIT;
}

/** จำนวนหน่วยขายต่อ 1 หน่วยรับเข้า (ต้อง > 0) */
export function getConversionFactor(factor?: number | string | null): number {
  const n = Number(factor ?? 1);
  if (!Number.isFinite(n) || n <= 0) return 1;
  return n;
}

/** มีหน่วยรับเข้าแยกจากหน่วยขาย */
export function usesAlternateReceiveUnit(config: VariantUnitConfig): boolean {
  return Boolean(config.receiveUnitLabel?.trim());
}

/** แปลงจำนวนรับเข้า → จำนวนหน่วยขาย (ปัดเป็นจำนวนเต็ม) */
export function convertReceiveQtyToStock(
  receiveQty: number,
  factor?: number | string | null,
): number {
  const f = getConversionFactor(factor);
  return Math.round(receiveQty * f);
}

export function formatQtyWithUnit(qty: number, unit?: string | null): string {
  const u = normalizeStockUnitLabel(unit);
  return `${qty.toLocaleString("lo-LA")} ${u}`;
}
